import React, { useState } from 'react'
import { useEffect } from 'react';
import logo from '../toolisoLogo.jpeg'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark, faUser } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { BadgeDollarSign } from 'lucide-react';

export default function Header() {
  let [loginSignup, setloginSignup] = useState(false);
  let [check, setCheck] = useState(false);
  let nav = useNavigate();
  let [showlogout, setShowlogout] = useState(false);
  let navigate = () => {
    nav('/');
  }
  const [token, setToken] = useState(localStorage.getItem('token') || "");

  // If you need to update token from other parts of your component
  useEffect(() => {
    // This will run once when component mounts
    const storedToken = localStorage.getItem('token');
    if (storedToken !== token) {
      setToken(storedToken || "");
    }
  }, []); // Empty dependency array means runs only once on 

  let handleToken = () => {
    setloginSignup(false);
    localStorage.removeItem('token');
    setToken("");
    setShowlogout(true);
    setTimeout(() => {
      setShowlogout(false);
     window.location.href = '/';
    }, 2000);
  }

  return (
    <div className="header">
      <div className="headImgDiv">
        <img src={logo} alt="" onClick={navigate} style={{ cursor: "pointer" }} />
      </div>
      <div className="navTools">
        <Link to={'/blogs'}>Blogs</Link>
        <a href="/#features">Tools</a>
        <a href="/#howItWorks">How it Works</a>
        <a href="/#benifits">Benifits</a>
        <a href="/#testimonials">Testimonials</a>
        {/* <Link to={'/pricing'}>Pricing</Link> */}
        <Link to={'/write-for-us-saas'}>Write for us</Link>
        <Link><FontAwesomeIcon icon={faUser} onClick={() => setloginSignup(!loginSignup)} /></Link>

      </div>
      {
        check ?
        <>
         {/* <Link to={'/pricing'} style={{ color: "rgb(234, 214, 29)" ,position: "absolute", right: "50px", top: "40px",}} className='barMenu'><BadgeDollarSign/></Link> */}
          <FontAwesomeIcon icon={faXmark} onClick={() => setCheck(false)} className='barMenu' style={{ color: "#f4d03f", position: "absolute", right: "90px", top: "40px", fontSize: "1.5rem", cursor: "pointer" }} />
         </>
          :
          <>
          {/* <Link to={'/pricing'} style={{ color: "rgb(234, 214, 29)" ,position: "absolute", right: "50px", top: "40px",}} className='barMenu'><BadgeDollarSign/></Link>*/}
          <FontAwesomeIcon icon={faBars} onClick={() => setCheck(true)} className='barMenu' style={{ color: "#f4d03f", position: "absolute", right: "90px", top: "40px", fontSize: "1.5rem", cursor: "pointer" }} />
        </>
      }
      <Link style={{ position: "relative", transform: "scale(1.1)", top: "2px" }} className='barMenu'><FontAwesomeIcon icon={faUser} onClick={() => setloginSignup(!loginSignup)} /></Link>
      <div className={`navToolMedia ${check ? "yesDisplay" : "noneDisplay"}`}>
        <Link to={'/blogs'}>Blogs</Link>
        <a onClick={() => setCheck(false)} style={{ color: "rgb(234, 214, 29)" }} href="/#features">Tools</a>
        <a onClick={() => setCheck(false)} style={{ color: "rgb(234, 214, 29)" }} href="/#howItWorks">How it Works</a>
        <a onClick={() => setCheck(false)} style={{ color: "rgb(234, 214, 29)" }} href="/#benifits">Benifits</a>
        <a onClick={() => setCheck(false)} style={{ color: "rgb(234, 214, 29)" }} href="/#testimonials">Testimonials</a>
        <Link onClick={() => setCheck(false)} to={'/write-for-us-saas'} style={{ color: "rgb(234, 214, 29)" }}>Write for us</Link>
      </div>

      {
        token === "" ?
          <div className={`headerLoginSignup ${loginSignup ? 'headerloginchecktwo' : 'headerlogincheck'}`}>
            <Link to={'/login'}>Login</Link>
            <Link to={'/signup'}>Signup</Link>
          </div>
          :
          <div className={`headerLoginSignup ${loginSignup ? 'headerloginchecktwo' : 'headerlogincheck'}`}>
            <Link onClick={handleToken}>logout</Link>
          </div>



      }
      {
        showlogout ?
          <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            backgroundColor: '#4CAF50', // Green background like success messages
            color: 'white',
            padding: '10px 20px',
            borderRadius: '4px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            zIndex: 1000,
            animation: 'fadeIn 0.3s ease-in-out'
          }}>
            Logged out successfully!
          </div>
          :
          ""
      }

    </div>
  )
}
